export class AssistanceBillComment {
  id?: number;
  bill_id?: number;
  comment?: string;
}
